import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import ConversationType from '../ConversationType';

const ConversationsContext = React.createContext();

const name = 'conversationsDataStore';

export const useConversations = () => React.useContext(ConversationsContext);

export const connectToConversations = makeConnectTo(ConversationsContext, name);

export default class ConversationsDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.element,
			PropTypes.func,
			PropTypes.array,
		]),
	};

	state = {
		conversations: [],
		isLoading: true,
	};

	render() {
		const conversationsDataStore = this.getStore();
		return (
			<ConversationsContext.Provider value={conversationsDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(conversationsDataStore)
					: this.props.children}
			</ConversationsContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchConversations();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.id !== this.props.id) {
			this.refreshConversations();
		}
	}

	componentWillUnmount() {
		if (this.conversationsFetch && this.conversationsFetch.cancel) {
			this.conversationsFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: noLoading => this.refreshConversations(noLoading),
		createNewTopic: values => this.createNewTopic(values),
		editExistingTopic: (topicId, values) =>
			this.editExistingTopic(topicId, values),
	});

	refreshConversations = noLoading => {
		if (!noLoading) {
			this.setState({
				isLoading: true,
			});
		}
		this.fetchConversations();
		return this.conversationsFetch.promise;
	};

	fetchConversations = () => {
		const { communityId } = this.props;
		const request = api.cancelableGet(
			`/api/v1/conversations/${communityId}`,
		);
		request.promise.then(this.cacheApiResponse);
		this.conversationsFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const conversations = apiResponse && this.getConversations(apiResponse);
		this.setState({
			conversations: conversations.sort(
				(a, b) =>
					new Date(b.mostRecentComment) -
					new Date(a.mostRecentComment),
			),
			isLoading: false,
		});
	};

	getConversations = apiResponse => {
		const { topics, products, threads } = apiResponse;
		return threads.map(conversation => {
			return {
				...conversation,
				product:
					conversation.conversationType ===
						ConversationType.Title.key &&
					products.filter(
						pr => pr.sku === conversation.conversationId,
					)[0],
				topic:
					!conversation.conversationType &&
					topics.filter(
						tp => tp.id === parseInt(conversation.conversationId),
					)[0],
			};
		});
	};

	createNewTopic = values => {
		const { communityId } = this.props;
		var topicDTO = {
			name: values.name,
			initialComment: values.initialComment,
		};

		api.post(`/api/v1/conversations/${communityId}/topics`, topicDTO).then(
			() => {
				this.refreshConversations(true);
			},
		);
	};

	editExistingTopic = (topicId, values) => {
		var topicDTO = {
			id: topicId,
			type: 0,
			name: values.name,
		};
		api.put(`/api/v1/conversations/topics`, topicDTO).then(() => {
			this.refreshConversations(true);
		});
	};
}
